import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetFacilityOccupancyRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string().refine((val) => !isNaN(Date.parse(val)), 'Invalid datetime'),
  to: z.string().refine((val) => !isNaN(Date.parse(val)), 'Invalid datetime'),
});

const GetFacilityOccupancyResponseDtoSchema = z.object({
  currentAvg: z.number().nullable(),
  changePct: z.number().nullable(),
});

export type GetFacilityOccupancyRequestDto = z.infer<
  typeof _GetFacilityOccupancyRequestDtoSchema
>;
export type GetFacilityOccupancyResponseDto = z.infer<
  typeof GetFacilityOccupancyResponseDtoSchema
>;

export const getFacilityOccupancy = (
  params: GetFacilityOccupancyRequestDto,
  config?: AxiosRequestConfig<GetFacilityOccupancyRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`/facilities/${facilityId}/occupancy`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetFacilityOccupancyResponseDtoSchema));
};
